<template>
  <div
    class="fixed bottom-60px flex left-1/2 transform !-translate-x-1/2 justify-center items-center"
  >
    <div class="w-960px h-170px trajectory relative p-20px text-white">
      <div class="h-20px flex justify-between items-center">
        <div class="text-20px font-400">轨迹回放</div>
        <div
          class="flex items-center justify-center absolute single-close w-24px h-24px right-20px z-999 cursor-pointer rounded-[50%]"
          @click="closeTrajectory()"
        >
          <span class="text-12px iconfont icon-line-close text-[#34b9f2]"></span>
        </div>
      </div>
      <div class="mt-10px h-50px">
        <div class="flex flex-row justify-between items-center text-14px h-20px">
          <span v-show="sliderBegin !== 0">
            {{
            dayjs((dayjs(sliderBegin).unix() + playProgress) * 1000).format('YYYY-MM-DD HH:mm:ss')
            }}
          </span>
          <span v-show="sliderEnd !== 0">{{ dayjs(sliderEnd).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </div>
        <el-slider
          :style="{ '--width': sliderWidth }"
          v-model="playProgress"
          :disabled="loadSlider"
          @change="sliderChange"
          :min="0"
          :max="sliderMaxLength"
          :format-tooltip="formatSliderTooltip"
          :marks="sliderMarkerList"
        ></el-slider>
      </div>
      <div class="mt-10px">
        <!-- 动画控制 -->
        <el-tooltip content="减速" placement="top" effect="dark">
          <span
            class="iconfont icon-bg-backward animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
            @click="changeSpeed('minus')"
          ></span>
        </el-tooltip>
        <el-tooltip content="播放" placement="top" effect="dark" v-if="!playStatus">
          <span
            @click="changeStatus(true)"
            class="iconfont icon-bg-play ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
          ></span>
        </el-tooltip>
        <el-tooltip content="暂停" placement="top" effect="dark" v-if="playStatus">
          <span
            @click="changeStatus(false)"
            class="iconfont icon-bg-pause ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
          ></span>
        </el-tooltip>
        <el-tooltip content="加速" placement="top" effect="dark">
          <span
            class="iconfont icon-bg-forward ml-10px animate-control w-30px h-30px inline-flex justify-center items-center text-14px"
            @click="changeSpeed('add')"
          ></span>
        </el-tooltip>
        <!-- 切换视角 -->
        <el-select
          v-if="!removeVisualAngle"
          class="ml-10px visual_input w-140px"
          v-model="visualAngle"
          value-key
          placeholder="切换视角"
          popper-class="visualization-select-popper"
          filterable
          size="mini"
          :disabled="!changeVisualAngleAble"
          @change="changeVisualAngle"
        >
          <el-option
            v-for="item in visualAngleList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- 播放速度 -->
        <el-select
          v-if="!removeSpeed"
          class="ml-10px visual_input w-80px"
          v-model="speed"
          size="mini"
          value-key
          placeholder="播放速度"
          clearable
          filterable
          :disabled="!changeSpeedAble"
          popper-class="visualization-select-popper"
          @change="changeSpeed"
        >
          <el-option
            v-for="item in speedOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <template v-if="!removeQuery">
          <!-- 时间选择框 -->
          <el-date-picker
            class="ml-10px visual_input"
            v-model="dateList"
            type="datetimerange"
            size="mini"
            popper-class="visualization-picker-popper"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :disabled="!changeTimeAble"
          ></el-date-picker>
          <!-- 查询-->
          <el-button
            type="primary"
            :loading="loadHistoryTrial"
            size="small"
            @click="getHistoryTrialData"
            :disabled="!changeTimeAble"
            class="ml-10px"
          >查询</el-button>
        </template>
        <el-button
          v-if="!removeCancelFollow"
          type="primary"
          size="small"
          @click="toggleFollow"
          :disabled="cancelFollowAble"
          class="ml-10px cancelBtn"
        >{{ isFollow ? '取消跟随' : '跟随'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { PersonnelApi } from '@wiz-api/personnel-position'
import personnelList from '../../../assets/js/componentMethods/personnelList'
import dayjs from 'dayjs'

const personnelApi = new PersonnelApi()
export default {
  name: 'trajectory',
  props: {
    /** 人员id */
    personnelId: {
      type: String,
      default: '',
    },
    /** 人员标签的code */
    tagCode: {
      type: String,
      default: '',
    },
    /** 云渲染实例 */
    cloudRender: {
      type: Object,
      default: () => {},
    },
    /** ModelId */
    modelId: {
      type: String,
      defalut: '',
    },
    /** 基础数据  */
    defaultData: {
      type: Object,
      default() {
        return {
          /** 时间搜索 */
          dateList: [],
          /** 播放速度 */
          speed: 0,
          /** 视角选择 */
          visualAngle: 2,
          /** 忽略空数据粒度 */
          ignoreNull: 500,
        }
      },
    },
    /** 是否允许切换时间 */
    changeTimeAble: {
      type: Boolean,
      default: true,
    },
    /** 是否允许切换速度 */
    changeSpeedAble: {
      type: Boolean,
      default: true,
    },
    /** 是否禁用取消跟随 */
    cancelFollowAble: {
      type: Boolean,
      default: true,
    },
    /** 是否允许切换视角 */
    changeVisualAngleAble: { type: Boolean, default: true },
    /** 是否移除查询组件 */
    removeQuery: { type: Boolean, default: false },
    /** 是否移除视角 */
    removeVisualAngle: { type: Boolean, default: false },
    /** 是否移除倍速 */
    removeSpeed: { type: Boolean, default: false },
    /** 是否移除取消跟随按钮 */
    removeCancelFollow: { type: Boolean, default: false },
  },
  watch: {
    /** 监听历史轨迹加载状态并抛出 */
    loadHistoryTrial(val) {
      this.$emit('HistoryLoading', val)
    },
  },
  data() {
    return {
      /** 播放状态 */
      playStatus: false,
      /** 播放进度 */
      playProgress: 0,
      /** 加载数据 */
      loadSlider: false,
      /** 最大长度 */
      sliderMaxLength: 1,
      /** 进度条开始值 */
      sliderBegin: 0,
      /** 进度条结束值 */
      sliderEnd: 0,
      /** 当前人员视角, 默认第二人称视角 */
      visualAngle: 2,
      /** 当前支持的视角集合 */
      visualAngleList: Object.freeze([
        {
          value: 1,
          label: '第一人称视角',
        },
        {
          value: 2,
          label: '第二人称视角',
        },
        {
          value: 3,
          label: '第三人称视角',
        },
      ]),
      visualAngleOffset: {
        1: [0, -0.6, 2.3],
        2: [0, -1, 0.5],
        3: [0, 0, 1.6],
      },
      /** 播放速度 */
      speed: 0,
      /** 当前支持的播放速度列表 */
      speedList: [1, 2, 4, 8],
      /** 当前支持的播放速度列表 */
      speedOption: Object.freeze([
        {
          value: 0,
          label: '1X',
        },
        {
          value: 1,
          label: '2X',
        },
        {
          value: 2,
          label: '4X',
        },
        {
          value: 3,
          label: '8X',
        },
      ]),
      /** 当前回放的时间 */
      dateList: [],
      /** 历史轨迹id，为之后操作动画 */
      historicalTrajectoryId: '',
      /** 当前人员名称 */
      currentPersonName: '',
      /** 历史轨迹加载状态 */
      loadHistoryTrial: false,
      /** 进度条标记宽度 */
      sliderWidth: '6px',
      /** 进度条的标记  */
      sliderMarkerList: {},
      /** 忽略空数据粒度 */
      ignoreNull: 0,
      /** 历史轨迹真实结束时间  */
      trueEndTime: null,
      /** 是否跟随  */
      isFollow: true,
    }
  },
  async created() {
    const socketEvent = new CustomEvent('operateSocket', {
      detail: {
        type: false,
      },
    })
    window.dispatchEvent(socketEvent)
    // 监听history变化
    const historicalTrajectoryEvent = new CustomEvent('HistoricalTrajectory', {
      detail: {
        isOpen: true,
      },
    })
    window.dispatchEvent(historicalTrajectoryEvent)
    this.cloudRender.Dispatch.on('HistoricalTrajectory', this.dealHistoricalTrajectory)
  },
  watch: {
    // 如果人员id改变了
    personnelId: {
      immediate: true,
      async handler() {
        // 清除时间
        this.dateList = []
        this.sliderBegin = 0
        this.sliderEnd = 0
        this.sliderMarkerList = {}
        this.trueEndTime = null
        this.playStatus = false
        this.playProgress = 0
        this.speed = 0
        this.isFollow = true
        // 如果有历史轨迹，则清除
        await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
        this.historicalTrajectoryId = ''
        await this.initData()
      },
    },
  },
  methods: {
    // 初始化数据
    async initData() {
      Object.keys(this.defaultData).forEach((key) => {
        if (key !== 'dateList') {
          this[key] = _.cloneDeep(this.defaultData[key])
        }
      })
      // 如果没有传递时间，则获取该标签最近一次有数据的时间
      if (_.isEmpty(this.defaultData.dateList)) {
        await this.getTagLastTime()
      } else {
        this.dateList = _.cloneDeep(this.defaultData.dateList)
      }
      if (!_.isEmpty(this.dateList)) {
        this.getHistoryTrialData()
      }
    },
    // 获取标签最后一次有数据的时刻
    async getTagLastTime() {
      const [err, res] = await personnelApi.getTagNewTime({
        tagIds: [this.tagCode],
      })
      if (!err) {
        if (!_.isEmpty(res)) {
          const newTime = _.get(_.head(res), 'newTime')
          if (newTime) {
            this.dateList = [dayjs(newTime).subtract(2, 'hour').format('YYYY-MM-DD HH:mm:ss'), dayjs(newTime).format('YYYY-MM-DD HH:mm:ss')]
          }
        } else {
          this.$emit('loadHistoryTrialEnd')
          return this.$message.warning({
            showClose: true,
            message: '暂无轨迹数据',
          })
        }
      }
    },
    /** 计算进度条的悬浮提示 */
    formatSliderTooltip() {
      return this.sliderBegin
        ? moment((moment(this.sliderBegin).unix() + this.playProgress) * 1000).format('HH:mm:ss')
        : '00:00:00'
    },
    /** 动画时间变化时 */
    async dealHistoricalTrajectory(data) {
      if (data.historyId === this.historicalTrajectoryId) {
        this.playProgress = moment(data.time).diff(this.dateList[0]) / 1000
        /** 判断此刻是否有数据，若没有数据且超过允许空值则暂停 */
        const markerList = Object.keys(this.sliderMarkerList)
        const exist = markerList.includes(this.playProgress.toString())
        let isPlay = true
        if (!exist) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < markerList.length; i++) {
            if (Number(markerList[i]) > this.playProgress) {
              if (Number(markerList[i]) > this.playProgress + this.ignoreNull) {
                isPlay = false
                break

                // eslint-disable-next-line no-useless-return
              }
              isPlay = true
              break
            }
          }
        }
        /** 如果播放到真实结束时间自动暂停 */
        const timeDiff = moment((moment(this.sliderBegin).unix() + this.playProgress) * 1000).diff(
          moment(this.trueEndTime)
        )
        if (timeDiff === 0) {
          isPlay = false
        }
        if (isPlay) return
        await this.cloudRender.HistoricalTrajectory.setStatus(this.historicalTrajectoryId, false)
        this.playStatus = false
      }
    },
    /** 进度条发生变化时 */
    async sliderChange(val) {
      const currentTime = moment(this.dateList[0])
        .add(this.playProgress * 1000)
        .format('YYYY-MM-DD HH:mm:ss')
      await this.cloudRender.HistoricalTrajectory.setTime(this.historicalTrajectoryId, currentTime)
    },
    /** 切换视角 */
    async changeVisualAngle() {
      // 如果是取消了跟随的就退出
      if (!this.isFollow) return
      await this.cloudRender.HistoricalTrajectory.setPersonFollow(
        this.historicalTrajectoryId,
        this.currentPersonName,
        this.visualAngle,
        {
          targetPosOffset: this.visualAngleOffset[this.visualAngle],
          defaultOffset: this.visualAngle === 3 ? [0, 1, 0] : undefined,
        }
      )
    },
    /** 查询历史轨迹 */
    async getHistoryTrialData() {
      const loadTrajectoryEvent = new CustomEvent('loadHistoryTrial')
      window.dispatchEvent(loadTrajectoryEvent)
      this.sliderWidth = '6px'
      if (this.dateList && this.dateList.length === 0 && !this.dateList[0] && !this.dateList[1]) {
        this.$message({
          message: '请选择时间',
          type: 'warning',
        })
        this.$emit('loadHistoryTrialEnd')
        return
      }
      this.loadHistoryTrial = true
      const query = {
        modelId: this.modelId,
        personnelId: this.personnelId,
        startTime: moment(this.dateList[0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(this.dateList[1]).format('YYYY-MM-DD HH:mm:ss'),
      }
      // 清空标记点
      this.sliderMarkerList = {}
      const [err, res] = await personnelApi.getPositionTrailList(
        query.personnelId,
        query.startTime,
        query.endTime,
        query.modelId
      )
      if (!err) {
        if (res) {
          this.sliderBegin = moment(this.dateList[0]).format('YYYY-MM-DD HH:mm:ss')
          this.sliderEnd = moment(this.dateList[1]).format('YYYY-MM-DD HH:mm:ss')
          this.sliderMaxLength = moment(this.dateList[1]).diff(moment(this.dateList[0])) / 1000
          /** 计算进度条标记的宽度 */
          const width = (1 / (this.sliderMaxLength - 1)) * 100
          this.sliderWidth = width <= 0.0017 ? '0.0017%' : `${width}%`
          /** 如果已有历史轨迹则销毁 */
          if (this.historicalTrajectoryId) {
            await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
            this.historicalTrajectoryId = ''
          }
          if (res.details.length === 0) {
            this.$message({
              message: '此时间段无历史数据',
              type: 'info',
            })
            this.loadHistoryTrial = false
            this.$emit('loadHistoryTrialEnd')
            return
          }
          this.trueEndTime = res.details[res.details.length - 1].timePoint
          await this.drawHistoryTrial(res)
        } else {
          this.$message({
            message: '此时间段无历史数据',
            type: 'info',
          })
          this.loadHistoryTrial = false
          this.$emit('loadHistoryTrialEnd')
          return
        }
      } else {
        this.sliderBegin = 0
        this.sliderEnd = 0
      }
      this.loadHistoryTrial = false
      this.$emit('loadHistoryTrialEnd')
    },
    /** 绘制历史轨迹 */
    async drawHistoryTrial(historyData) {
      const marks = {}
      const keyframeData = historyData.details.map((trialItem) => {
        /** 为有数据返回的数据添加标记 */
        if (moment(trialItem.timePoint).unix() !== moment(this.dateList[1]).unix()) {
          Object.assign(marks, {
            [moment(trialItem.timePoint).unix() - moment(this.dateList[0]).unix()]: '',
          })
        }
        return {
          time: moment(trialItem.timePoint).format('YYYY-MM-DD HH:mm:ss'),
          point: [trialItem.posX, trialItem.posY, trialItem.posZ],
        }
      })
      this.sliderMarkerList = marks
      const personHistoryData = [
        {
          name: historyData.personnelName,
          keyframeData: keyframeData,
        },
      ]
      const markerOption = {
        id: this.personnelId,
        pos: [0, 0, 0],
        background: 'sample',
        visible: true,
        nodeOffset: [0, 0],
        text: historyData.personnelName,
        textColor: '#ffff00ff',
        hasTriangle: true,
        markPosType: 4,
      }
      this.historicalTrajectoryId = this.generateUUID()
      const result = await this.cloudRender.HistoricalTrajectory.create(
        this.historicalTrajectoryId,
        personHistoryData,
        {
          personOption: {
            markerOption,
          },
        }
      )
      await this.cloudRender.HistoricalTrajectory.setSpeed(
        this.historicalTrajectoryId,
        this.speedList[this.speed]
      )
      this.currentPersonName = historyData.personnelName
      // 跟随人员
      this.changeVisualAngle()
    },
    /** 修改状态 */
    async changeStatus(playStatus) {
      if (this.loadHistoryTrial) {
        return this.$message({
          message: '正在加载......,请稍后再试!',
          type: 'info',
        })
      }
      /** 判断此刻是否有数据如果没有数据则跳到下一时间段 */
      const markerList = Object.keys(this.sliderMarkerList)
      const exist = markerList.includes(this.playProgress.toString())
      if (!exist) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < markerList.length; i++) {
          if (Number(markerList[i]) > this.playProgress) {
            this.playProgress = Number(markerList[i])
            // eslint-disable-next-line no-useless-return
            break
          }
        }
        /** 跳转至有数据时间 */
        const currentTime = moment(this.dateList[0])
          .add(this.playProgress * 1000)
          .format('YYYY-MM-DD HH:mm:ss')
        await this.cloudRender.HistoricalTrajectory.setTime(
          this.historicalTrajectoryId,
          currentTime
        )
      }
      await this.cloudRender.HistoricalTrajectory.setStatus(this.historicalTrajectoryId, playStatus)
      this.playStatus = playStatus
    },
    /** 关闭历史轨迹 */
    async closeTrajectory() {
      const socketEvent = new CustomEvent('operateSocket', {
        detail: {
          type: true,
        },
      })
      window.dispatchEvent(socketEvent)
      const historicalTrajectoryEvent = new CustomEvent('HistoricalTrajectory', {
        detail: {
          isOpen: false,
        },
      })
      window.dispatchEvent(historicalTrajectoryEvent)
      if (this.historicalTrajectoryId) {
        // 关闭历史轨迹
        await this.cloudRender.HistoricalTrajectory.destroy(this.historicalTrajectoryId)
        this.historicalTrajectoryId = ''
      }
      this.$emit('closeTrajectory')
    },
    /** 切换速度 */
    async changeSpeed(type) {
      if (type === 'add' && this.speed < 3) {
        this.speed += 1
      } else if (type === 'minus' && this.speed > 0) {
        this.speed -= 1
      }
      await this.cloudRender.HistoricalTrajectory.setSpeed(
        this.historicalTrajectoryId,
        this.speedList[this.speed]
      )
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    /** 切换跟随 */
    async toggleFollow() {
      this.isFollow = !this.isFollow
      if (this.isFollow) {
        this.changeVisualAngle()
      } else {
        await this.cloudRender.HistoricalTrajectory.cancelPersonFollow()
      }
    },
  },
  async beforeDestroy() {
    await this.closeTrajectory()
  },
}
</script>
<style lang="scss">
@import '../../../assets/styles/select.scss';
</style>
<style lang="scss" scoped>
.trajectory {
  border-radius: 4px;
  background: linear-gradient(158.1deg, #0b232e 37.5%, #13455e 101.79%),
    linear-gradient(154.36deg, #77daff 3.57%, rgba(52, 185, 242, 0.4) 90.08%);
  .animate-control {
    border-radius: 50%;
    background: #134860;
  }
  .cancelBtn {
    width: 80px !important;
  }
}
::v-deep .el-slider__stop {
  position: absolute;
  height: 6px;
  width: var(--width);
  border-radius: 0;
  background-color: #15cea0;
  z-index: 2;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}
// 可视化input
::v-deep .el-input__inner {
  border: 1px solid #d1e6ff4d !important ;
  border-radius: 4px !important;
  background: transparent !important;
  font-size: 14px !important;
  color: #fff !important;
}
::v-deep.el-date-editor .el-range-input {
  background: transparent !important;
  color: #fff !important;
}
::v-deep.el-slider__runway {
  background-color: #134860 !important;
  height: 4px !important;
  margin: 5px 0 !important;
  .el-slider__button {
    width: 8px !important;
    height: 8px !important;
    border: 1px solid #03ffec !important;
  }
}
::v-deep.el-button {
  background: linear-gradient(
      170.88deg,
      rgba(5, 240, 255, 0.0001) 37.75%,
      rgba(59, 255, 245, 0.4) 82.46%
    ),
    linear-gradient(180deg, rgba(6, 240, 255, 0.12) 0.44%, rgba(9, 247, 247, 0.24) 100%) !important;
  box-shadow: 0px 2px 7px rgba(0, 100, 132, 0.3), inset 0px 1px 15px rgba(20, 199, 238, 0.2) !important;
  border-radius: 4px !important;
  border: #29bab1 !important;
  width: 70px !important;
}
::v-deep .el-slider__bar {
  background-color: #03ffec !important;
  z-index: 5;
}
::v-deep.el-slider__button {
  border: 2px solid #409eff;
}
::v-deep.el-date-editor .el-range-separator {
  background: transparent !important;
  color: #fff !important;
}
::v-deep.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 390px !important;
}
.single-close {
  background: linear-gradient(146.24deg, #114e67, #0a364d),
    radial-gradient(circle at 50% 50%, #59c8fc 0, rgba(82, 172, 229, 0) 100%);
  border: 1px solid #34b9f2;
}
</style>
